import { render } from "./DetailsSection.vue?vue&type=template&id=371ee270"
import script from "./DetailsSection.vue?vue&type=script&lang=ts"
export * from "./DetailsSection.vue?vue&type=script&lang=ts"
script.render = render

export default script